import React, { useCallback, useEffect, useState } from 'react'

import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import styles from '../../css/style.module.css'
import { FaPlus } from "react-icons/fa6";
import { IoSearchSharp } from "react-icons/io5";




import img from '../../assest/loading1.gif'
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import Pagination from '../../components/Pagination/Pagination';


const columns = [
  'S.no',
  'UserName',
  'Wallet ID',
  'Wallet Balance',
  'Last Transaction',
  // 'Transaction Type',
  'Total Transactions',
];




const UserWalletManagement = () => {
  const navigate = useNavigate()
  const [walletdata, setWalletData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('')
  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page: 1,
    hasPrevPage: false,
    hasNextPage: false,
  });


  const fetchData = useCallback(async () => {
    await getApi(endPoints.getalluser(pagination.page, pagination.limit, search), {
      setResponse: setWalletData,
      setLoading,
      errorMsg: 'Failed to fetch data!'
    });
  }, [pagination.page, pagination.limit, search]);

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: walletdata?.data?.totalPages,
      hasPrevPage: walletdata?.data?.hasPrevPage,
      hasNextPage: walletdata?.data?.hasNextPage,
    }));
  }, [walletdata]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);






  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
  };

  const routeMapping = {
    'User Wallet': "/wallet-management/user",
    'Staff Wallet': "/wallet-management/staff",
  };

  return (
    <>
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Wallet Management</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color='#8A8A8A' size={20} />
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className={styles.rightbuttons}>
            <div className={styles.rightbuttons2} onClick={() => navigate('/wallet-management/addfunds')}>
              <FaPlus color='#FFFFFF' />
              <p>Add Funds</p>

            </div>
            {/* <div className={styles.filterbutton} onClick={toggleDropdown}>
              <VscSettings color='#737373' size={20} />
              <p>Filters</p>
            </div> */}
          </div>
        </div>
        <div className={styles.jobselectcontainer}>
          <div className={styles.jobStatusContainer}>
            {['User Wallet', 'Staff Wallet'].map((item, index) => (
              <Link key={index} to={routeMapping[item]} className={styles.link}>
                <p
                  className={
                    item === 'User Wallet'
                      ? styles.jobOptionTrueactive
                      : styles.jobOptionnotactive
                  }
                >
                  {item}
                </p>
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="10" className={styles.loadingCell}>
                      <img src={img} alt="Loading..." width={100} height={100} />
                    </td>
                  </tr>
                ) : walletdata?.data?.docs?.length ? (
                  walletdata?.data?.docs?.map((item, index) => (
                    <tr key={item?._id} className={styles.tableRow}>
                      <td>{index + 1}</td>
                      <td>{item?.firstName} {item?.lastName}</td>
                      <td>{item?.Id}</td>
                      <td>{item?.wallet}</td>
                      <td>{item?.lastTransactionType}</td>
                      {/* <td>{item?.type}</td> */}
                      <td>{item?.totalTransaction}</td>
                      {/* <td>
                        <div className={styles.tableaction}>
                          <FaRegEdit size={20} />
                          <RiDeleteBin6Line size={20} onClick={() => openDeleteModal(item._id)} />
                        </div>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className={styles.noDataCell}>No data available.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
          />
        </div>

      </div >
    </>
  )
}

export default HOC(UserWalletManagement)
